var toString = require('../internals/to-string');

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/normalize-string-argument.js
// module id = 252
// module chunks = 0 1